import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import OttoCredentialsSubTab from "./Otto/OttoCredentials";
import OttoArticlesSubTab from "./Otto/Articles/OttoArticles";
import OttoPriceSetterSubTab from "./Otto/OttoConfiguration";
import ProxySubTab from "./Otto/ProxySubTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const OttoTab = ({ initialSku = null, onNavConsumed, onNavigateToBase }) => {
  const [ottoSubTab, setOttoSubTab] = useState(1);

  React.useEffect(() => {
    if (initialSku) {
      setOttoSubTab(1);
    }
  }, [initialSku]);

  const handleOttoSubTabChange = (event, newValue) => {
    setOttoSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={ottoSubTab}
              onChange={handleOttoSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Credentials" />
              <Tab label="Articles" />
              <Tab label="Configuration" />
              <Tab label="Proxies" />
            </Tabs>
          </Box>

          {/* Credentials Tab */}
          <TabPanel value={ottoSubTab} index={0}>
            <OttoCredentialsSubTab />
          </TabPanel>

          {/* Articles Tab */}
          <TabPanel value={ottoSubTab} index={1}>
            <OttoArticlesSubTab
              initialSku={initialSku}
              onSkuConsumed={onNavConsumed}
              onNavigateToBase={onNavigateToBase}
            />
          </TabPanel>

          {/* Configuration Tab */}
          <TabPanel value={ottoSubTab} index={2}>
            <OttoPriceSetterSubTab />
          </TabPanel>

          {/* Proxy Settings Tab */}
          <TabPanel value={ottoSubTab} index={3}>
            <ProxySubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OttoTab;
